/* eslint-disable no-undef */
/* eslint-disable import/newline-after-import */
import videojs from 'video.js';
window.videojs = videojs;

require('videojs-contrib-quality-levels');
require('videojs-hotkeys/videojs.hotkeys');
require('videojs-vtt.js');
require('../dep/videojs.persistvolume');
require('@silvermine/videojs-chromecast')(videojs, { preloadWebComponents: true });
require('@silvermine/videojs-airplay')(videojs, { preloadWebComponents: true });

export { videojs };
